export default {
  "mainVegetable": "groenten",
  "mainVegetable/01": "groenten/aubergine",
  "mainVegetable/02": "groenten/asperges",
  "mainVegetable/03": "groenten/avocado",
  "mainVegetable/04": "groenten/rode-bieten",
  "mainVegetable/05": "groenten/broccoli",
  "mainVegetable/06": "groenten/wortelen",
  "mainVegetable/07": "groenten/selderij",
  "mainVegetable/08": "groenten/champignons",
  "mainVegetable/09": "groenten/kool",
  "mainVegetable/10": "groenten/spruiten",
  "mainVegetable/11": "groenten/chinese-kool",
  "mainVegetable/12": "groenten/bloemkool",
  "mainVegetable/13": "groenten/koolsalade",
  "mainVegetable/14": "groenten/komkommer",
  "mainVegetable/15": "groenten/courgettes",
  "mainVegetable/16": "groenten/witloof",
  "mainVegetable/17": "groenten/spinazie",
  "mainVegetable/18": "groenten/tuinbonen",
  "mainVegetable/19": "groenten/peulbonen",
  "mainVegetable/20": "groenten/peultjes",
  "mainVegetable/21": "groenten/gedroogde-bonen",
  "mainVegetable/22": "groenten/sperziebonen",
  "mainVegetable/23": "groenten/linzen",
  "mainVegetable/24": "groenten/macedoine",
  "mainVegetable/25": "groenten/mais",
  "mainVegetable/26": "groenten/sla-melange",
  "mainVegetable/27": "groenten/rapen",
  "mainVegetable/28": "groenten/uien",
  "mainVegetable/29": "groenten/doperwtjes",
  "mainVegetable/30": "groenten/paprika",
  "mainVegetable/31": "groenten/krielaardappeltjes",
  "mainVegetable/32": "groenten/scheuten",
  "mainVegetable/33": "groenten/radijsjes",
  "mainVegetable/34": "groenten/eikenbladsla",
  "mainVegetable/35": "groenten/krulsla",
  "mainVegetable/36": "groenten/ijsbergsla",
  "mainVegetable/37": "groenten/piedmont-salade",
  "mainVegetable/38": "groenten/rijstsalade",
  "mainVegetable/39": "groenten/romeinse-sla",
  "mainVegetable/40": "groenten/scheuten",
  "mainVegetable/41": "groenten/sla",
  "mainVegetable/42": "groenten/veldsla",
  "mainVegetable/43": "groenten/rucola",
  "mainVegetable/44": "groenten/schorseneren",
  "mainVegetable/45": "groenten/tabbouleh",
  "mainVegetable/46": "groenten/tomaten",
  "mainVegetable/47": "groenten/boterboontjes",
  "mainVegetable/48": "groenten/kikkererwten",
  "mainVegetable/49": "groenten/peren",
  "mainVegetable/50": "groenten/pompoen",
  "mainVegetable/51": "groenten/rode-kidneybonen",
  "mainVegetable/52": "groenten/appelen",
  "mainVegetable/53": "groenten/kastanjes",
  "mainVegetable/54": "groenten/pruimen",
  "mainVegetable/55": "groenten/julienne",
  "mainVegetable/56": "groenten/zwarte-olijven",
  "mainVegetable/57": "groenten/artisjokken",
  "mainVegetable/58": "groenten/rode-paprika",
  "mainVegetable/59": "groenten/snijbonen",
  "mainVegetable/60": "groenten/jonge-groenten",
  "mainVegetable/61": "groenten/ratatouille",
  "mainVegetable/62": "groenten/couscous",
  "mainVegetable/63": "groenten/tajine",
  "mainVegetable/64": "groenten/groenten-voor-curry",
  "mainVegetable/65": "groenten/spliterwten",
  "mainVegetable/66": "groenten",
  "mainVegetable/67": "groenten/coral-lenzen",
  "mainVegetable/68": "groenten/quinoa",
  "mainVegetable/69": "groenten/spelt",
  "mainVegetable/70": "groenten/bulgur",
  "mainVegetable/71": "groenten/rode-kool",
  "mainVegetable/72": "groenten/boerenkool",
  "mainVegetable/73": "groenten/kervel",
  "mainVegetable/74": "groenten/granen-en-zaden",
  "mainVegetable/75": "groenten/peulvruchten",
  "mainVegetable/76": "groenten/zoete-aardappel",
  "mainVegetable/77": "groenten/pompoen",
  "mainVegetable/78": "groenten/zurkel",
  "mainVegetable/79": "groenten/bonen",
  "mainVegetable/80": "groenten/doperwtjes-worteltjes",
  "mainVegetable/81": "groenten/erwten",
  "mainVegetable/82": "groenten/edamame",
  "mainVegetable/83": "groenten",
  "mainVegetable/84": "groenten",
  "mainVegetable/85": "groenten",
  "mainVegetable/86": "groenten",
  "mainVegetable/87": "groenten",
  "mainVegetable/88": "groenten",
  "mainVegetable/89": "groenten",
  "mainVegetable/90": "groenten",
  "mainVegetable/91": "groenten",
  "mainVegetable/92": "groenten",
  "mainVegetable/93": "groenten",
  "mainVegetable/94": "groenten",
  "mainVegetable/95": "groenten",
  "mainVegetable/96": "groenten",
  "mainVegetable/97": "groenten",
  "mainVegetable/98": "groenten",
  "season": "seizoenen",
  "season/1": "seizoenen/zomer",
  "season/2": "seizoenen/herfst",
  "season/3": "seizoenen/winter",
  "season/4": "seizoenen/lente",
  "season/5": "seizoenen",
  "technologie": "technologie",
  "technologie/AC01": "technologie/blik",
  "technologie/AD01": "technologie/vriesvers",
  "technologie/AG01": "technologie/fees",
  "technologie/AT01": "technologie/cateraar",
  "recipeDish": "type-of-flat",
  "recipeDish/ACC": "type-of-flat/bijgerecht",
  "recipeDish/APE": "type-of-flat/drinken",
  "recipeDish/DES": "type-of-flat/nagerecht",
  "recipeDish/ENT": "type-of-flat/voorgerecht",
  "recipeDish/PLAT": "type-of-flat/hoofdgerecht",
  "recipeDish/SAL": "type-of-flat/salade",
  "recipeDish/SNA": "type-of-flat/tussendoor",
  "recipeDish/PDE": "type-of-flat/ontbijt",
  "recipeDish/DEJ": "type-of-flat/lunch",
  "recipeDish/TRA": "type-of-flat",
  "recipeDish/GOU": "type-of-flat",
  "recipeDish/ETH": "type-of-flat",
  "recipeDish/FCH": "type-of-flat",
  "recipeDish/SOU": "type-of-flat",
  "pred-recipeTimingCook-facet": "koken",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "koken/0-15-minuten",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "koken/15-30-minuten",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "koken/30-45-minuten",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "koken/45-minuten",
  "pred-recipeTimingPreparation-facet": "voorbereiding",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "voorbereiding/0-15-minuten",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "voorbereiding/15-30-minuten",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "voorbereiding/30-45-minuten",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "voorbereiding/45-minuten",
  "pred-recipeCost-Facet": "budget",
  "pred-recipeCost-Facet/petit": "budget/klein",
  "pred-recipeCost-Facet/moyen": "budget/gemiddeld",
  "pred-recipeCost-Facet/grand": "budget/ruim",
  "recipeDifficulty": "moeilijkheid",
  "recipeDifficulty/1": "moeilijkheid/eenvoudig",
  "recipeDifficulty/2": "moeilijkheid/gemiddeld",
  "recipeDifficulty/3": "moeilijkheid/moeilijk",
  "recipeDishNumber": "gasten",
  "recipeDishNumber/1": "gasten/1",
  "recipeDishNumber/2": "gasten/2",
  "recipeDishNumber/3": "gasten/3",
  "recipeDishNumber/4": "gasten/4",
  "recipeDishNumber/5": "gasten/5",
  "recipeDishNumber/6": "gasten/6",
  "recipeDishNumber/7": "gasten/7",
  "recipeDishNumber/8": "gasten/8",
  "recipeTheme": "recpten-per-thema",
  "recipeTheme/01": "recpten-per-thema",
  "recipeTheme/02": "recpten-per-thema",
  "recipeTheme/03": "recpten-per-thema",
  "recipeTheme/04": "recpten-per-thema",
  "recipeTheme/05": "recpten-per-thema",
  "recipeTheme/06": "recpten-per-thema",
  "recipeTheme/07": "recpten-per-thema",
  "recipeTheme/08": "recpten-per-thema",
  "recipeTheme/09": "recpten-per-thema",
  "recipeTheme/10": "recpten-per-thema",
  "recipeTheme/11": "recpten-per-thema",
  "recipeTheme/12": "recpten-per-thema",
  "recipeTheme/13": "recpten-per-thema",
  "recipeTheme/14": "recpten-per-thema",
  "recipeTheme/15": "recpten-per-thema",
  "recipeTheme/16": "recpten-per-thema",
  "recipeTheme/17": "recpten-per-thema",
  "recipeTheme/18": "recpten-per-thema",
  "recipeTheme/19": "recpten-per-thema",
  "recipeTheme/20": "recpten-per-thema",
  "recipeTheme/21": "recpten-per-thema",
  "recipeTheme/22": "recpten-per-thema",
  "recipeTheme/23": "recpten-per-thema",
  "recipeTheme/24": "recpten-per-thema",
  "recipeTheme/25": "recpten-per-thema/mexicaans",
  "recipeTheme/26": "recpten-per-thema/de-wereld-rond",
  "recipeTheme/27": "recpten-per-thema/dagje-zonder-vlees",
  "recipeTheme/28": "recpten-per-thema/laag-in-koolhydraten",
  "recipeTheme/33": "recpten-per-thema",
  "recipeTheme/34": "recpten-per-thema",
  "recipeTheme/35": "recpten-per-thema",
  "recipeTheme/36": "recpten-per-thema",
  "recipeTheme/37": "recpten-per-thema",
  "recipeTheme/38": "recpten-per-thema",
  "recipeTheme/39": "recpten-per-thema",
  "recipeTheme/40": "recpten-per-thema",
  "recipeTheme/41": "recpten-per-thema",
  "recipeTheme/42": "recpten-per-thema",
  "recipeTheme/43": "recpten-per-thema",
  "recipeTheme/44": "recpten-per-thema",
  "recipeTheme/45": "recpten-per-thema",
  "recipeTheme/46": "recpten-per-thema",
  "pred-particularite": "dieet",
  "pred-particularite/Sans%20conservateur": "dieet/geen-conserveringsmiddelen",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "dieet/natuurlijk-voorkomend-zout",
  "pred-particularite/Sans%20colorant": "dieet",
  "pred-particularite/Sans%20sucre%20ajout%E9": "dieet/geen-toegevoegd-suiker",
  "pred-particularite/Sans%20sel%20ajout%E9": "dieet",
  "pred-particularite/Sans%20additif": "dieet",
  "pred-particularite/": "dieet",
  "pred-particularite/Sans%20lactose": "dieet/lactosevrij",
  "pred-particularite/Sans%20gluten": "dieet/glutenvrij",
  "pred-particularite/V%E9g%E9tarien": "dieet/vegetarisch",
  "pred-particularite/V%E9g%E9talien": "dieet/vegan",
  "pred-particularite/Sans%20sulfite": "dieet",
  "pred-particularite/A%20la%20vapeur": "dieet/met-stoom-bereid",
  "pred-particularite/Sans%20condiment": "dieet",
  "cultureType": "soort-cultuur",
  "cultureType/Bio": "soort-cultuur/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "soort-cultuur",
  "cultureType/Sans%20OGM": "soort-cultuur",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "dieet/vegan",
  "pred-particularite/recipeVeggie": "dieet/vegetarisch",
  "pred-particularite/recipeGlutenfree": "dieet/glutenvrij",
  "pred-particularite/recipeLactosefree": "dieet/lactosevrij"
};
